
import config from "@/config";
import http from "@/utils/request";


export default {
    radarlist:{
        url: `${config.MAIN_URL}/meteorology/radar`,
		name: "雷达列表",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
    },
	isCollect:{
        url: `${config.MAIN_URL}/meteorology/collect`,
		name: "是否搜藏",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
    },
	satelLite:{
        url: `${config.MAIN_URL}/meteorology/weixing`,
		name: "卫星图",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
    },
	aDvance:{
        url: `${config.MAIN_URL}/meteorology/advance`,
		name: "预告图",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
    },
	queryByPage:{
        url: `${config.MAIN_URL}/api/v1/meteorology/airport/queryByPage`,
		name: "部分机场气象分页",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
    },
	collects:{
        url: `${config.MAIN_URL}/meteorology/my/collects`,
		name: "我的收藏",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
    },
	linequeryByPage:{
        url: `${config.MAIN_URL}/api/v1/meteorology/airline/queryByPage`,
		name: "部分航线气象分页",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
    },
	airportNameList:{
        url: `${config.MAIN_URL}/api/v1/meteorology/airport/AirportNameList`,
		name: "部分机场气象下拉",
		get: async function (params) {
			return await http.get(this.url+ params);
		}
    },
	AirLineNameList:{
        url: `${config.MAIN_URL}/api/v1/meteorology/airline/AirLineNameList`,
		name: "部分航线气象下拉",
		get: async function (params) {
			return await http.get(this.url+ params);
		}
    }
	
}